import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ErrorsPage from 'components/Errors';
import LoadingIndicator from 'components/LoadingIndicator';
import { useFetchSpecialRightsQuery } from 'redux/api/authorization.api';

import { setSpecialRights } from '../actions';
import { selectRouteParams } from '../selectors';
import { ResponsiveLayout } from './responsive-layout';
import { useLayout } from './use-layout';

function Layout({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useSelector(selectRouteParams());
  const { data: specialRightsData } = useFetchSpecialRightsQuery();

  useEffect(
    () => {
      if (specialRightsData) {
        dispatch(setSpecialRights(specialRightsData));
      }
    },
    [dispatch, specialRightsData],
  );

  const { error } = useLayout();
  const loaded = location?.pathname === params?.location;

  return (
    <ResponsiveLayout>
      {!loaded && <LoadingIndicator size="40" />}
      {!error && loaded && children}
      {error && <ErrorsPage title={error.toString()} />}
    </ResponsiveLayout>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
